export default __webpack_public_path__ + "static/media/august2023-4.6a8f78b9.jpg";